(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-customer-addresses"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-edit]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var box = document.getElementById('edit-' + a.getAttribute('data-edit'));
      if (box) box.hidden = !box.hidden;
    });
  });
  // Seleciona o valor salvo comparando com o value ou com o texto da opção
  // (o país salvo pode vir como "Brasil" enquanto o value da opção é "Brazil").
  function selectDefault(sel) {
    var def = (sel.getAttribute('data-default') || '').trim().toLowerCase();
    if (!def) return;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (o.value.toLowerCase() === def || o.text.trim().toLowerCase() === def) { sel.selectedIndex = i; return; }
    }
  }

  // Preenche o campo Estado com os estados do país escolhido (atributo data-provinces
  // que a Shopify coloca em cada opção de país). Países sem estados escondem o campo.
  function syncProvinces(countrySel, provinceSel, field) {
    var opt = countrySel.options[countrySel.selectedIndex];
    var provinces = [];
    try { provinces = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) { provinces = []; }
    provinceSel.innerHTML = '';
    if (!provinces.length) {
      field.hidden = true;
      provinceSel.disabled = true;
      return;
    }
    field.hidden = false;
    provinceSel.disabled = false;
    var blank = document.createElement('option');
    blank.value = '';
    blank.textContent = 'Selecione';
    provinceSel.appendChild(blank);
    provinces.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p[0];
      o.textContent = p[1];
      provinceSel.appendChild(o);
    });
    selectDefault(provinceSel);
  }

  document.querySelectorAll('form').forEach(function (form) {
    var country = form.querySelector('select[name="address[country]"]');
    if (!country) return;
    selectDefault(country);
    var province = form.querySelector('select[name="address[province]"]');
    var field = form.querySelector('[data-province-field]');
    if (!province || !field) return;
    syncProvinces(country, province, field);
    country.addEventListener('change', function () {
      province.setAttribute('data-default', '');
      syncProvinces(country, province, field);
    });
  });
  document.querySelectorAll('[data-confirm]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (!window.confirm('Tem certeza que deseja excluir este endereço?')) e.preventDefault();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-customer-login"]) return;
  try {
    
(function () {
  var login = document.getElementById('mm-login');
  var recover = document.getElementById('mm-recover');
  if (!login || !recover) return;
  function show(el, other) { el.hidden = false; other.hidden = true; }
  document.querySelectorAll('[data-recover-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); show(recover, login); });
  });
  document.querySelectorAll('[data-recover-close]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); show(login, recover); });
  });
  if (window.location.hash === '#mm-recover') show(recover, login);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('mm-product-form');
  var dataEl = document.getElementById('mm-variants-data');
  if (!root || !dataEl) return;

  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = document.getElementById('mm-variant-id');
  var priceEl = document.getElementById('mm-pdp-price');
  var stockEl = document.getElementById('mm-pdp-stock');
  var addBtn = document.getElementById('mm-add-btn');
  var installEl = document.getElementById('mm-pdp-installments');
  var whatsEl = document.getElementById('mm-pdp-whats');
  var lowEl = document.getElementById('mm-pdp-lowstock');
  var notifyEl = document.getElementById('mm-notify');
  var notifyVariant = document.getElementById('mm-notify-variant');
  var buyArea = root.querySelector('.mm-pdp__buy');
  var media = document.getElementById('mm-pdp-media');

  // Tamanhos na ordem da grade (PP P M G GG, 01 02 03..., bebe RN/PB/MB/GB antes
  // dos numeros). A ordem do Shopify vem da ordem em que os SKUs chegaram e,
  // quando nem toda cor tem todos os tamanhos, o Shopify nao deixa reordenar.
  // So muda a posicao dos botoes: a variante e escolhida pelo valor marcado.
  (function () {
    if (!root) return;
    var LETTER = ['RN', 'PP', 'P', 'PB', 'M', 'MB', 'G', 'GB', 'GG', 'XG', 'EG', 'XGG', 'EGG', 'EXG', 'EXGG', 'G1', 'G2', 'G3', 'G4', 'G5', 'G6'];
    var LAST = ['U', 'UN', 'UNICO', 'ÚNICO', 'TU', 'DV'];
    function clean(v) { return String(v).replace(/\s*\(\d+\)\s*$/, '').trim().toUpperCase(); }
    function isNum(v) { return /^\d+([.,]\d+)?$/.test(clean(v)); }
    Array.prototype.forEach.call(root.querySelectorAll('.mm-pdp__option'), function (opt) {
      var label = opt.querySelector('.mm-pdp__option-label');
      var wrap = opt.querySelector('.mm-pdp__values');
      if (!label || !wrap || !/^(tamanho|tamanhos|size)$/i.test(label.textContent.trim())) return;
      var pairs = Array.prototype.map.call(wrap.querySelectorAll('.mm-pdp__radio'), function (r, i) {
        return { radio: r, label: wrap.querySelector('label[for="' + r.id + '"]'), value: r.value, i: i };
      });
      var values = pairs.map(function (p) { return p.value; });
      var lettersFirst = values.some(isNum) && values.some(function (v) { return LETTER.indexOf(clean(v)) >= 0; });
      function rank(v) {
        var s = clean(v);
        if (isNum(s)) return [lettersFirst ? 1 : 0, parseFloat(s.replace(',', '.'))];
        var l = LETTER.indexOf(s);
        if (l >= 0) return [lettersFirst ? 0 : 1, l];
        var z = LAST.indexOf(s);
        if (z >= 0) return [3, z];
        return [2, 0];
      }
      pairs.sort(function (a, b) {
        var x = rank(a.value), y = rank(b.value);
        return x[0] - y[0] || x[1] - y[1] || a.i - b.i;
      });
      pairs.forEach(function (p) {
        wrap.appendChild(p.radio);
        if (p.label) wrap.appendChild(p.label);
      });
    });
  })();

  // Videos da galeria.
  // - Tocam mudos so enquanto estao visiveis e pausam ao sair (todas as telas).
  // - Celular: o 1o quadro abre com a foto; o primeiro video carrega por baixo e,
  //   quando fica pronto, assume o 1o quadro com transicao suave (a foto vira o
  //   2o item). Nada acontece se a cliente ja mexeu na galeria, se demorar mais
  //   de 8s, com economia de dados ou com "reduzir movimento" ligado.
  (function () {
    if (!media) return;
    var videoCells = media.querySelectorAll('.mm-pdp__cell--video');
    if (!videoCells.length) return;
    var conn = navigator.connection || {};
    var lowData = Boolean(conn.saveData) || /(^|-)2g$/.test(conn.effectiveType || '');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoPlay = !lowData && !reduceMotion;

    Array.prototype.forEach.call(videoCells, function (cell) {
      var video = cell.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.addEventListener('playing', function () { cell.classList.add('is-playing'); });
      video.addEventListener('pause', function () { cell.classList.remove('is-playing'); });
    });

    if (autoPlay && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });
      Array.prototype.forEach.call(videoCells, function (cell) {
        var video = cell.querySelector('video');
        if (video) observer.observe(video);
      });
    }

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
    var first = media.firstElementChild;
    var videoCell = videoCells[0];
    var video = videoCell.querySelector('video');
    if (!autoPlay || !isMobile || !video || !first || first === videoCell || first.classList.contains('mm-pdp__cell--video')) return;

    var touched = false;
    var markTouched = function () { touched = true; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (evt) {
      media.addEventListener(evt, markTouched, { passive: true, once: true });
    });
    media.addEventListener('scroll', function () { if (media.scrollLeft > 2) touched = true; }, { passive: true });
    if (root) root.addEventListener('change', markTouched); // troca de cor/tamanho move a galeria

    var giveUp = setTimeout(function () { touched = true; }, 8000);
    var swapped = false;

    function swapIn() {
      if (swapped || touched) return;
      swapped = true;
      clearTimeout(giveUp);
      var photo = first.querySelector('img');
      var cover = null;
      if (photo) {
        cover = document.createElement('img');
        cover.className = 'mm-pdp__cover';
        cover.alt = '';
        cover.src = photo.currentSrc || photo.src;
        videoCell.appendChild(cover);
      }
      // Mesma posicao de rolagem (0): o video entra no 1o quadro e a foto vira o 2o.
      media.insertBefore(videoCell, first);
      media.scrollLeft = 0;
      var hideCover = function () {
        if (!cover) return;
        cover.classList.add('is-hidden');
        setTimeout(function () { if (cover && cover.parentNode) cover.parentNode.removeChild(cover); }, 700);
      };
      video.addEventListener('playing', hideCover, { once: true });
      var p = video.play();
      if (p && p.catch) p.catch(hideCover);
    }

    video.preload = 'auto';
    video.addEventListener('canplay', swapIn, { once: true });
    video.load();
  })();
  var currency = priceEl ? priceEl.getAttribute('data-currency') : 'BRL';

  function money(cents) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2);
    }
  }

  function installmentsHtml(price) {
    if (!installEl) return '';
    var max = parseInt(installEl.getAttribute('data-max'), 10) || 6;
    var min = parseInt(installEl.getAttribute('data-min'), 10) || 5000;
    var n = 1;
    for (var i = 1; i <= max; i++) {
      if (Math.floor(price / i) >= min) n = i;
    }
    if (n < 2 || price <= 0) return '';
    return '<span class="mm-installments">ou ' + n + 'x de <strong>' + money(Math.floor(price / n)) + '</strong> sem juros</span>';
  }

  function selectedOptions() {
    var radios = root.querySelectorAll('.mm-pdp__radio:checked');
    var opts = [];
    Array.prototype.forEach.call(radios, function (r) {
      opts[parseInt(r.getAttribute('data-option-position'), 10) - 1] = r.value;
    });
    return opts;
  }

  function matchVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // Texto sem acento, minúsculo e só com letras/números, para comparar nomes de cor.
  function norm(text) {
    return ' ' + String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  }

  // Posição (1, 2 ou 3) da opção de cor, pelo nome da opção ("Cor", "Cores", "Color").
  var colorPosition = (function () {
    var found = 0;
    Array.prototype.forEach.call(root.querySelectorAll('.mm-pdp__option'), function (opt) {
      var label = opt.querySelector('.mm-pdp__option-label');
      var radio = opt.querySelector('.mm-pdp__radio');
      if (!found && label && radio && /^(cor|cores|color|colour)$/i.test(label.textContent.trim())) {
        found = parseInt(radio.getAttribute('data-option-position'), 10);
      }
    });
    return found;
  })();

  // Descobre qual foto mostrar para a variante, nesta ordem:
  // 1) foto ligada à própria variante; 2) foto ligada a outra variante da mesma cor;
  // 3) foto cujo texto alternativo cita a cor; 4) foto cujo nome de arquivo cita a cor.
  function mediaForVariant(variant) {
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (!colorPosition || !media) return null;
    var color = variant.options[colorPosition - 1];
    if (!color) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[colorPosition - 1] === color && v.featured_media && v.featured_media.id) return v.featured_media.id;
    }
    var needle = norm(color);
    if (needle.trim() === '') return null;
    var cells = Array.prototype.slice.call(media.querySelectorAll('[data-media-id]'));
    var byAlt = cells.filter(function (c) { return norm(c.getAttribute('data-media-alt')).indexOf(needle) !== -1; })[0];
    if (byAlt) return byAlt.getAttribute('data-media-id');
    var byFile = cells.filter(function (c) {
      var src = (c.getAttribute('data-zoom-src') || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
      return norm(src).indexOf(needle) !== -1;
    })[0];
    return byFile ? byFile.getAttribute('data-media-id') : null;
  }

  // Mostra a foto da variante escolhida. No celular a galeria é um carrossel: rola até a foto.
  // No desktop é uma grade: leva a foto para a primeira posição, sem rolar a página.
  function showMedia(mediaId) {
    if (!media || !mediaId) return;
    var cell = media.querySelector('[data-media-id="' + mediaId + '"]');
    if (!cell) return;
    if (media.scrollWidth > media.clientWidth + 1) {
      media.scrollTo({ left: cell.offsetLeft - media.offsetLeft, behavior: 'smooth' });
    } else if (media.firstElementChild !== cell) {
      media.insertBefore(cell, media.firstElementChild);
    }
  }

  function update() {
    var variant = matchVariant(selectedOptions());
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; }
      return;
    }
    if (idInput) idInput.value = variant.id;

    if (priceEl) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<s class="mm-pdp__compare">' + money(variant.compare_at_price) + '</s>';
        html += '<span class="mm-pdp__off">-' + off + '%</span>';
      }
      html += '<span class="mm-pdp__now">' + money(variant.price) + '</span>';
      priceEl.innerHTML = html;
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Adicionar à sacola' : 'Produto esgotado';
    }
    if (stockEl) {
      stockEl.innerHTML = variant.available
        ? '<span class="mm-pdp__in">● Em estoque</span>'
        : '<span class="mm-pdp__out">● Esgotado</span>';
    }
    if (installEl) installEl.innerHTML = installmentsHtml(variant.price);
    if (whatsEl && whatsEl.getAttribute('data-base')) {
      var waMsg = 'Olá! Tenho uma dúvida sobre este produto: ' + whatsEl.getAttribute('data-title');
      if (whatsEl.getAttribute('data-single') !== 'true' && variant.title) waMsg += ' (' + variant.title + ')';
      waMsg += ' ' + whatsEl.getAttribute('data-origin') + whatsEl.getAttribute('data-product-url') + '?variant=' + variant.id;
      whatsEl.href = whatsEl.getAttribute('data-base') + encodeURIComponent(waMsg);
    }
    if (lowEl) {
      var threshold = parseInt(lowEl.getAttribute('data-threshold'), 10) || 5;
      var qty = variant.inventory_quantity;
      if (variant.available && variant.inventory_management === 'shopify' && qty > 0 && qty <= threshold) {
        lowEl.innerHTML = '🔥 Últimas peças! Restam apenas <strong>' + qty + '</strong>.';
        lowEl.hidden = false;
      } else {
        lowEl.hidden = true;
      }
    }
    if (notifyEl && !notifyEl.querySelector('.mm-pdp__notify-ok')) {
      notifyEl.hidden = variant.available;
      if (buyArea) buyArea.style.display = variant.available ? '' : 'none';
      if (notifyVariant) notifyVariant.value = variant.title || '';
    }
    showMedia(mediaForVariant(variant));
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(null, '', url.toString());
    }
  }

  root.addEventListener('change', function (e) {
    if (e.target.classList.contains('mm-pdp__radio')) update();
  });

  var qtyInput = root.querySelector('.mm-qty__input');
  Array.prototype.forEach.call(root.querySelectorAll('.mm-qty__btn'), function (btn) {
    btn.addEventListener('click', function () {
      var step = parseInt(btn.getAttribute('data-qty'), 10);
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val + step);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url || this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      var self = this;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var el = doc.querySelector('product-recommendations');
          if (el && el.innerHTML.trim().length) {
            self.innerHTML = el.innerHTML;
          }
        })
        .catch(function () {});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
